var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.userLogged)?_c('v-main',[_c('Header'),_c('MenuNav'),_c('router-view')],1):_c('Login'),_c('AppLoading'),_c('AppAlert')],1)}
var staticRenderFns = []

export { render, staticRenderFns }